<template>
  <div class="mutation-container col-sm-12">
    <div class="mutation">
      <div
        v-if="submitted && erreurMutation != null"
        class="alert alert-danger text-left global-errors"
      >
        <p>
          {{ erreurMutation }}
        </p>
      </div>

      <div
        v-if="erreurGlobale != null"
        class="alert alert-danger text-left global-errors mb-5"
      >
        <p>
          {{ erreurGlobale }}
        </p>
      </div>

      <p class="mutation-title">
        {{ "mutation_title" | translate("fr") }}
      </p>

      <div class="mutation-part-1 mt-5">
        <div class="row title">
          {{ "mutation_title_1" | translate("fr") }}
        </div>
        <div class="row mt-3">
          <p class="mutation_text">
            {{ "mutation_title_1_text_1" | translate("fr") }}
          </p>
          <p class="mutation_text" style="font-weight:bold">
            {{ preinscription.data.organismeQuitte.code }} -
            {{ preinscription.data.organismeQuitte.libelle }}
          </p>
          <p class="mutation_text">
            {{ "mutation_title_1_text_2" | translate("fr") }}
          </p>
          <p class="mutation_text" style="font-weight:bold">
            {{ this.getComiteCode(preinscription.data.organismeQuitte.code) }}
          </p>
        </div>
        <div class="row">
          <p
            class="mutation_text mb-0"
            style="white-space: pre-wrap; text-align: left;"
          >
            {{ "mutation_title_1_text_3" | translate("fr") }}
          </p>
        </div>
      </div>

      <div class="mutation-part-2 mt-5">
        <div class="row title">
          {{ "mutation_title_2" | translate("fr") }}
        </div>
        <div class="row mt-3">
          <p class="mutation_text">
            {{ "mutation_title_2_text_1" | translate("fr") }}
          </p>
          <p class="mutation_text" style="font-weight:bold">
            {{ preinscription.data.organisme.code }} -
            {{ preinscription.data.organisme.libelle }}
          </p>
          <p class="mutation_text">
            {{ "mutation_title_2_text_2" | translate("fr") }}
          </p>
          <p class="mutation_text" style="font-weight:bold">
            {{ this.getComiteCode(preinscription.data.organisme.code) }}
          </p>
        </div>
        <div class="row">
          <p
            class="mutation_text mb-0"
            style="white-space: pre-wrap; text-align: left;"
          >
            {{ "mutation_title_2_text_3" | translate("fr") }}
          </p>
        </div>
      </div>

      <div
        v-if="
          listeJustificatifs.filter(
            j => j.type === 'MUTATION' || j.type === 'DOMICILE'
          ).length > 0
        "
        class="mutation-part-3 mt-5"
      >
        <div class="row title">
          {{ "mutation_title_3" | translate("fr") }}
        </div>

        <div class="row mt-3">
          <p
            class="mutation_text"
            style="white-space: pre-wrap; text-align: left;"
          >
            {{ "mutation_title_3_text_1" | translate("fr") }}
            {{ preinscription.data.saison.code.substring(0, 2) }}
            {{ "mutation_title_3_text_2" | translate("fr") }}
            {{ preinscription.data.saison.code.substring(0, 2) }}
            {{ "mutation_title_3_text_3" | translate("fr") }}
            {{ preinscription.data.saison.code.substring(0, 2) }}
            {{ "mutation_title_3_text_4" | translate("fr") }}
          </p>
        </div>

        <div class="mes-justificatifs">
          <justificatif-domicile-modale
            v-if="
              listeJustificatifs.filter(j => j.type === 'DOMICILE').length > 0
            "
            :token="token_out"
            :preinscription="preinscription"
            v-on:getJustificatifDomicileAcceptee="
              getJustificatifDomicileAcceptee
            "
          >
          </justificatif-domicile-modale>

          <justificatif-mutation-modale
            v-if="
              listeJustificatifs.filter(j => j.type === 'MUTATION').length > 0
            "
            :token="token_out"
            :preinscription="preinscription"
            v-on:getJustificatifMutationAcceptee="
              getJustificatifMutationAcceptee
            "
          >
          </justificatif-mutation-modale>
        </div>
      </div>

      <div class="mt-5">
        <b-button
          id="buttonValidation"
          variant="outline-primary"
          @click="validationMutation(false /*isReconnected*/)"
          ><b-spinner
            v-if="isLoading === true"
            small
            label="Loading"
            class="mr-1"
          ></b-spinner>
          <span>JE VALIDE</span></b-button
        >
      </div>

      <div
        v-if="submitted && erreurMutation != null"
        class="alert alert-danger text-left global-errors mt-3"
      >
        <p>
          {{ erreurMutation }}
        </p>
      </div>

      <div
        v-if="erreurGlobale != null"
        class="alert alert-danger text-left global-errors mt-3"
      >
        <p>
          {{ erreurGlobale }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import JustificatifDomicileModale from "@/components/general/JustificatifDomicileModale.vue";
import JustificatifMutationModale from "@/components/general/JustificatifMutationModale.vue";

import preinscriptionAppelsServeur from "@/preinscriptionUtils";
import translations from "@/Translations.js";
import { BSpinner } from "bootstrap-vue";
import _ from "lodash";

export default {
  components: {
    JustificatifDomicileModale,
    JustificatifMutationModale,
    BSpinner
  },
  props: {
    preinscription: null,
    token: null,
    locale: {
      type: String,
      default: "fr"
    }
  },
  data() {
    return {
      erreurGlobale: null, // valorisée dans traitementErreursServeur
      erreurMutation: null,
      listeJustificatifs: [],
      submitted: false,
      isLoading: false,
      token_out: undefined
    };
  },
  filters: {
    translate: function(value, locale) {
      return translations[locale][value];
    }
  },
  watch: {
    token: function() {
      if (this.token) {
        this.token_out = JSON.parse(JSON.stringify(this.token));
      }
    }
  },
  methods: {
    validationMutation() {
      this.submitted = true;
      this.erreurMutation = null;
      //on peut continuer meme si les justificatifs ne sont tous fournis et validés
      this.callServeur(false /*isReconnected*/);
    },
    getComiteCode(organismeCode) {
      // à récupérer dans le code organisme exemple : ARA0038046 => 0038
      // (et on enlève la suite de 0 en début de chaîne ce qui donnerait ici du comité 38))
      let comiteCode = organismeCode.substring(3, 7);
      return _.trimStart(comiteCode, "0");
    },
    getJustificatifs(isReconnected) {
      var that = this;
      preinscriptionAppelsServeur
        .getJustificatifs(this.token_out, true /*mutation*/)
        .then(result => {
          that.listeJustificatifs = result.data;
        })
        .catch(error => {
          // a rajouter les arguments de la methode(sauf isReconnected), si necessaire ex: argsArray.push(arg1);
          var argsArray = [];
          preinscriptionAppelsServeur.traitementErreursServeur(
            error,
            isReconnected,
            that,
            that.getJustificatifs,
            argsArray
          );
        });
    },
    getJustificatifDomicileAcceptee(isConditionAcceptee) {
      let justificatifDomicile = _.find(this.listeJustificatifs, {
        type: "DOMICILE"
      });
      if (justificatifDomicile) {
        justificatifDomicile.present = isConditionAcceptee;
      }
    },
    getJustificatifMutationAcceptee(isConditionAcceptee) {
      let justificatifMutation = _.find(this.listeJustificatifs, {
        type: "MUTATION"
      });
      if (justificatifMutation) {
        justificatifMutation.present = isConditionAcceptee;
      }
    },
    callServeur(isReconnected) {
      var that = this;
      // quand l'utilisateur fait click sur le bouton "JE VALIDE", le bouton devient grisé et un spinner apparait sur le bouton
      this.disableValidation(true);
      preinscriptionAppelsServeur
        .postEtape(this.token_out, 2, 3, true, this.preinscription.data)
        .then(result => {
          that.preinscription.data = result;

          // le bouton "JE VALIDE" devient actif si la validation côté serveur est bien passée
          that.disableValidation(false);
        })
        .catch(error => {
          // a rajouter les arguments de la methode(sauf isReconnected), si necessaire ex: argsArray.push(arg1);
          var argsArray = [];
          preinscriptionAppelsServeur.traitementErreursServeur(
            error,
            isReconnected,
            that,
            that.callServeur,
            argsArray
          );

          if (that.erreurGlobale != null && that.erreurGlobale != "") {
            // le bouton "JE VALIDE" devient actif si la validation côté serveur n'est pas bien passée
            that.disableValidation(false);
          }
        });
    },
    disableValidation(isDisabled) {
      var buttonValidation = document.getElementById("buttonValidation");
      buttonValidation.disabled = isDisabled;
      this.isLoading = isDisabled;
    }
  },
  created() {
    // la clone token_out est utilisée pour pouvoir mettre a jour le token si la session a expiré (on peut pas modifier directement un prop)
    if (this.token) {
      this.token_out = JSON.parse(JSON.stringify(this.token));
    }
  },
  mounted() {
    this.getJustificatifs(false /*isReconnected*/);
  }
};
</script>

<style scoped>
.mutation-container {
  display: flex;
  background-color: #ffffff;
  min-height: 200px;
}

/* laptops & desktops */
@media (min-width: 1025px) {
  .mutation {
    margin: 3rem 8rem;
    width: 100%;
  }

  .mutation-title {
    font-family: Lato;
    font-weight: bold;
    font-size: 20px;
    margin-bottom: 30px;
  }

  .mutation_text {
    font-family: Lato;
    font-weight: normal;
    font-size: 16px;
    white-space: pre;
  }

  .mes-justificatifs {
    display: inline-flex;
  }
}

/* mobile phone */
@media (max-width: 480px) {
  .mes-justificatifs {
    display: inline-grid;
  }

  .mutation {
    margin: 10px 15px;
    width: 100%;
  }

  .mutation-title {
    font-family: Lato;
    font-weight: bold;
    font-size: 16px;
    margin-bottom: 30px;
  }

  .mutation_text {
    font-family: Lato;
    font-weight: normal;
    font-size: 13px;
    white-space: pre;
  }

  .mutation .btn {
    width: 100%;
  }
}

/* tablet */
@media (min-width: 481px) and (max-width: 1024px) {
  .mutation {
    margin: 3rem 3rem;
    width: 100%;
  }

  .mutation-title {
    font-family: Lato;
    font-weight: bold;
    font-size: 20px;
    margin-bottom: 30px;
  }

  .mutation_text {
    font-family: Lato;
    font-weight: normal;
    font-size: 16px;
    white-space: pre;
  }

  .mes-justificatifs {
    display: inline-flex;
  }
}

.btn-outline-primary {
  background-color: #003690 !important;
  border-color: #003690 !important;
  width: 206px;
  height: 54px;
  border-radius: 27px !important;
}
</style>
